import React, { createContext, useContext, useState } from 'react';

interface BookingContextType {
  isBookingPopupOpen: boolean;
  openBookingPopup: () => void;
  closeBookingPopup: () => void;
}

const BookingContext = createContext<BookingContextType | undefined>(undefined);

export function BookingProvider({ children }: { children: React.ReactNode }) {
  const [isBookingPopupOpen, setIsBookingPopupOpen] = useState(false);

  const openBookingPopup = () => setIsBookingPopupOpen(true);
  const closeBookingPopup = () => setIsBookingPopupOpen(false);

  return (
    <BookingContext.Provider value={{
      isBookingPopupOpen,
      openBookingPopup,
      closeBookingPopup
    }}>
      {children}
    </BookingContext.Provider>
  );
}

export function useBooking() {
  const context = useContext(BookingContext);
  if (context === undefined) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
}
